import { useApiIsLoaded, useMapsLibrary } from "@vis.gl/react-google-maps";

export function MapLoader({ children }: { children: JSX.Element }): JSX.Element {
  const markers = useMapsLibrary("marker");
  const isLoaded = useApiIsLoaded();
  return isLoaded && markers ? children : <>Please wait...</>;
}
